import React, { useEffect, useRef, useState } from "react";
import "./Profile.css";
import {
  getAddress,
  getPhone,
  getSortedTags,
  getRating,
  checkIsOpen,
  getPlaceHoursByDay,
  getStarsImages,
  checkIsWholeTimeOpen,
  getPlaceHoursString,
  getEventDate,
  getEventDayName,
  getEventHours,
  getDistanceByUserLocation,
  getLatLng,
} from "./placeUtils";
import Tag from "./Tag";
import Comment from "./Comment";
import CreateComment from "./CreateComment";
import Review from "./Review";
import axios from "axios";
import { Link, useLocation, useParams } from "react-router-dom";
import "./Profile2.css";
import Crunches from "./Crunches";
import ImagePlaceholder from "./ImagePlaceholder";

function Profile(props) {
  const [showCreateComment, setShowCreateComment] = useState(true);
  const [responseText, setResponseText] = useState({
    color: "",
    content: "",
  });
  const { id } = useParams();
  const location = useLocation();
  const breadcrumbBack = location.state?.breadcrumbBack;
  const [target, setTarget] = useState(null);
  const [distance, setDistance] = useState("");
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
  const descriptionMoreRef = useRef(null);
  const mapRef = useRef(null);
  const mapMarkerRef = useRef(null);
  let placeCheck = false;
  const descriptionLength = 600;
  const mapZoom = 15;

  useEffect(() => {
    checkPlace();

    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const latLng = getLatLng(target?.location);
    if (!latLng || !mapRef.current) {
      return;
    }

    const applyLatLng = () => {
      mapRef.current.center = latLng;
      mapRef.current.zoom = mapZoom;
      if (mapMarkerRef.current) {
        mapMarkerRef.current.position = latLng;
      }
    };

    if (window.customElements?.get("gmp-map")) {
      applyLatLng();
    } else {
      window.customElements?.whenDefined("gmp-map").then(applyLatLng);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target?.location]);

  useEffect(() => {
    if (distance === "" && target?.location !== undefined && target?.location !== null) {
      setDistance(getDistanceByUserLocation(target.location));
    }
  }, [target, distance]);

  useEffect(() => {
    const node = descriptionMoreRef.current;
    if (!node) {
      return;
    }

    node.style.maxHeight = isDescriptionExpanded ? node.scrollHeight + "px" : "";
  }, [isDescriptionExpanded, target]);

  function checkPlace() {
    if (placeCheck) {
      return;
    } else {
      placeCheck = true;
    }

    if (props.target === "place") {
      getPlace(id);
    } else {
      getEvent(id);
    }
  }

  function getPlace(id) {
    if (id === undefined || id === null) {
      return;
    }

    if (props.places === undefined || props.places.length <= 0) {
      axios({
        method: "GET",
        data: {
          ip: props.addressIp,
        },
        withCredentials: true,
        url: process.env.REACT_APP_SERVER_URL + process.env.REACT_APP_FETCH_SINGLE_PLACE_URL + id,
      })
        .then((res) => {
          setTarget(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      const found = props.places.find((element) => element._id === id);
      if (found) {
        setTarget(found);
        sendReport(found._id);
      }
    }
  }

  function getEvent(id) {
    if (id === undefined || id === null) {
      return;
    }

    if (props.events === undefined || props.events.length <= 0) {
      axios({
        method: "GET",
        data: {
          ip: props.addressIp,
        },
        withCredentials: true,
        url: process.env.REACT_APP_SERVER_URL + process.env.REACT_APP_FETCH_SINGLE_EVENT_URL + id,
      })
        .then((res) => {
          setTarget(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      const found = props.events.find((element) => element._id === id);
      if (found) {
        setTarget(found);
        sendReport(found._id);
      }
    }
  }

  function sendReport(id) {
    axios
      .get(
        (props.target === "place"
          ? process.env.REACT_APP_SERVER_URL + process.env.REACT_APP_COUNT_PLACE_URL
          : process.env.REACT_APP_SERVER_URL + process.env.REACT_APP_COUNT_EVENT_URL) + id,
      )
      .then((result) => {})
      .catch((err) => {
        console.log(err);
      });
  }

  function postNewComment(place, comment) {
    return axios.post(
      props.target === "place"
        ? process.env.REACT_APP_SERVER_URL + process.env.REACT_APP_POST_COMMENT
        : process.env.REACT_APP_SERVER_URL + process.env.REACT_APP_POST_EVENT_COMMENT,
      {
        targetId: place._id,
        comment: comment.content,
        rating: comment.rating,
      },
      { withCredentials: true },
    );
  }

  function refreshTarget() {
    const url = props.target === "place" ? process.env.REACT_APP_FETCH_SINGLE_PLACE_URL : process.env.REACT_APP_FETCH_SINGLE_EVENT_URL;
    axios
      .get(process.env.REACT_APP_SERVER_URL + url + id + "?t=" + Date.now(), { withCredentials: true })
      .then((res) => setTarget(res.data))
      .catch((err) => console.log(err));
  }

  function onAddComment(comment) {
    if (checkForValidate(comment) === false) {
      return;
    }

    postNewComment(target, comment)
      .then(() => {
        setShowCreateComment(false);
        setResponseText({ color: "green", content: "Komentarz został poprawnie dodany." });
        refreshTarget();
      })
      .catch((err) => {
        console.log(err);
        const status = err.response?.status;
        const content =
          status === 401
            ? "Zaloguj się ponownie, aby dodać komentarz."
            : status === 403
              ? "Twoje konto nie może dodawać komentarzy."
              : "Nie udało się dodać komentarza. Spróbuj ponownie.";
        setResponseText({ color: "red", content });
      });
  }

  function checkForValidate(comment) {
    for (let i = 0; i < props.bannedWords.length; i++) {
      if (comment.content.includes(props.bannedWords[i])) {
        setResponseText({ color: "red", content: "Komentarz zawiera niedozwone słowo." });
        return false;
      }
    }

    return true;
  }

  function checkForCreateComment() {
    if (props.userData === undefined || target === undefined || target.commentsAndRatings === undefined) {
      return null;
    }

    return props.userData === undefined || props.userData._id === undefined
      ? false
      : !target.commentsAndRatings.find((item) => item.userId === props.userData._id);
  }

  let targetCommentsAndRating = "";
  if (target !== undefined && target !== null) {
    targetCommentsAndRating = getRating(target.commentsAndRatings, target.reviews);
  }

  function hoursElement() {
    let hoursArray = [
      { day: "Pon:", value: 1 },
      { day: "Wt:", value: 2 },
      { day: "Śr:", value: 3 },
      { day: "Czw:", value: 4 },
      { day: "Pt:", value: 5 },
      { day: "Sob:", value: 6 },
      { day: "Ndz:", value: 0 },
    ];

    return (
      <ul>
        <li>
          <div className="menu">
            <p className="menu-title">
              <span className={checkIsOpen(target) ? "itsOpen" : "itsClose"}>
                {getPlaceHoursString(target) + " "}
                <img className="menu-title-arrow" src={process.env.PUBLIC_URL + "/icons/triangular down.png"} alt="" />
              </span>
            </p>
            <ul className="menu-dropdown">
              <li className="profile-hours-tooltip-heading">Godziny otwarcia</li>
              {hoursArray.map((item) => (
                <li
                  className={`${getPlaceHoursByDay(target, item.value).open === "" ? "itsClose" : "itsOpen"} ${item.value === new Date().getDay() ? "is-today" : ""}`}
                  key={item.value}
                >
                  <p>
                    {item.day + " "}
                    {getPlaceHoursByDay(target, item.value).open === ""
                      ? "nieczynne"
                      : checkIsWholeTimeOpen(target, item.value)
                        ? "całą dobę"
                        : getPlaceHoursByDay(target, item.value).open}
                    {getPlaceHoursByDay(target, item.value).open !== "00:00" &&
                    getPlaceHoursByDay(target, item.value).close !== "00:00" &&
                    getPlaceHoursByDay(target, item.value).open[0] !== "w" &&
                    getPlaceHoursByDay(target, item.value).open !== ""
                      ? " - " + getPlaceHoursByDay(target, item.value).close
                      : null}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </li>
      </ul>
    );
  }

  return (
    <div>
      {target === undefined || target === null ? (
        <div className="loader"></div>
      ) : (
        <div className="profile-header">
          <Crunches target={target} backOverride={breadcrumbBack} />

          <div className="profile">
            <div className="profile-body">
              <div>
                <div className="row">
                  <div className="col-xl-8 col-lg-12">
                    <div>
                      <h2>{target.title}</h2>
                      <div className="profile-rating-quick" aria-label="Ocena">
                        <span className="profile-rating-quick-label">Ocena</span>
                        <strong>
                          {targetCommentsAndRating === undefined ? "-" : targetCommentsAndRating.finalRating}
                        </strong>
                        <span className="profile-rating-quick-stars">
                          {targetCommentsAndRating === undefined ? "☆" : getStarsImages(targetCommentsAndRating.stars)}
                        </span>
                        <span className="profile-rating-quick-count">
                          {targetCommentsAndRating === undefined
                            ? "Brak ocen"
                            : `${targetCommentsAndRating.votes} ocen`}
                        </span>
                      </div>
                      <hr></hr>
                    </div>

                    <div>
                      <div className="d-flex profile-tags">
                        <p className="profile-tags-title">Tagi:</p>
                        <div className="d-flex profile-tags-tags flex-wrap">
                          {target.tags === undefined || target.tags.length <= 0 || target.tags === undefined
                            ? null
                            : target.tags[0].name !== null &&
                                target.tags[0].name !== undefined &&
                                target.tags[0].name !== ""
                              ? getSortedTags(target).map((tag) => {
                                  return <Tag key={tag._id} tagName={tag.name} />;
                                })
                              : null}
                        </div>
                      </div>
                      <hr></hr>
                    </div>
                  </div>

                  <div className="col-4">
                    <div className="profile-image">
                      <div>
                        <ImagePlaceholder
                          src={target.images?.[0]?.img}
                          type={props.target}
                          alt={target.title}
                          loading="eager"
                        />
                        {target.images?.[0]?.author && (
                          <p className="profile-image-author">{target.images[0].author}</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row profile-section">
                  <div className="col-12 profile-info-column">
                    <h4>Informacje</h4>

                    <div className="profile-info-primary">
                      {props.target === "place" ? (
                        <div className="profile-hours-summary">
                          <p>Czynne dzisiaj:</p>
                          {hoursElement()}
                        </div>
                      ) : (
                        <div className="event-date">
                          <p>
                            Data: <span>{getEventDate(target) + " "}</span>
                            {getEventDayName(target)}
                          </p>
                          <p>
                            Godzina: <span>{getEventHours(target)}</span>
                          </p>
                        </div>
                      )}

                      <div className="event-phone">
                        <p>Telefon</p>
                        {getPhone(target) === "-" ? (
                          "-"
                        ) : (
                          <a href={"tel:+48" + getPhone(target)}>
                            <img
                              className="profile-icon-telephone"
                              src={process.env.PUBLIC_URL + "/icons/telephone.png"}
                              alt=""
                            />
                            {getPhone(target)}
                          </a>
                        )}
                      </div>

                      <div className="event-address">
                        <p>Adres</p>
                        {props.target === "event" && target.placeWebpage && target.placeWebpage !== "-" ? (
                          <p>
                            <a href={target.placeWebpage} rel="noreferrer" target="_blank">
                              {getAddress(target)}
                            </a>
                          </p>
                        ) : (
                          <p>{getAddress(target)}</p>
                        )}

                        {getAddress(target) !== "-" && (
                          <p>
                            <a
                              href={
                                "https://www.google.com/maps/search/?api=1&query=" +
                                encodeURIComponent(getAddress(target))
                              }
                              rel="noreferrer"
                              target="_blank"
                              className="profile-address-map-link"
                            >
                              Pokaż mapę
                            </a>
                          </p>
                        )}

                        {target.location !== undefined && target.location !== null ? (
                          distance === "" || distance === undefined || distance === null ? null : distance < 1000 ? (
                            <p>Odległość: {Math.floor(distance)} m</p>
                          ) : (
                            <p>
                              Odległość: {(distance / 1000).toString().split(".")[0]}.
                              {(distance / 1000).toString().split(".")[1].slice(0, 2)} km
                            </p>
                          )
                        ) : null}
                      </div>

                      <div className="profile-webpage profile-info-website">
                        <p>{props.target === "place" ? "Strona internetowa" : "Strona internetowa wydarzenia"}</p>
                        {(() => {
                          const websiteUrl = props.target === "place" ? target.webpage : target.eventWebpage;
                          if (!websiteUrl || websiteUrl === "-") {
                            return <span>-</span>;
                          }
                          const domain = websiteUrl.replace(/^(https?:\/\/)?(www\.)?/, "").split(/[/?#]/)[0];
                          const displayText = "www." + domain;
                          return (
                            <a href={websiteUrl} rel="noreferrer" target="_blank" title={websiteUrl}>
                              {displayText}
                            </a>
                          );
                        })()}
                      </div>

                      {props.target === "event" ? (
                        <div className="profile-tickets">
                          <p>Bilety do kupienia na: </p>
                          {target.tickets?.length ? (
                            target.tickets.map((ticket, index) => {
                              return (
                                <div className="ticket" key={index}>
                                  <a className="btn btn-primary" href={ticket.link} rel="noreferrer" target="_blank">
                                    {ticket.name}
                                  </a>
                                </div>
                              );
                            })
                          ) : (
                            <p className="profile-tickets-empty">Brak informacji o biletach</p>
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="profile-section profile-gallery">
                  <h4>Galeria</h4>

                  <div
                    id="carouselExampleAutoplaying3"
                    className="carousel slide carousel-fade"
                    data-bs-ride="carousel"
                  >
                    {target.images?.[1]?.img && (
                      <div className="carousel-indicators">
                        <button
                          type="button"
                          data-bs-target="#carouselExampleAutoplaying3"
                          data-bs-slide-to="0"
                          className="active"
                          aria-current="true"
                          aria-label="Zdjęcie 1"
                        ></button>
                        <button
                          type="button"
                          data-bs-target="#carouselExampleAutoplaying3"
                          data-bs-slide-to="1"
                          aria-label="Zdjęcie 2"
                        ></button>
                        {target.images?.[2]?.img && (
                          <button
                            type="button"
                            data-bs-target="#carouselExampleAutoplaying3"
                            data-bs-slide-to="2"
                            aria-label="Zdjęcie 3"
                          ></button>
                        )}
                      </div>
                    )}
                    <div className="carousel-inner">
                      {target.images !== undefined && target.images[0] !== undefined && target.images[0].img ? (
                        <div className="carousel-item active" data-bs-interval="1000000">
                          <div className="d-block w-100 carousel-image-frame">
                            <div
                              className="carousel-image-backdrop"
                              style={{ backgroundImage: `url(${target.images[0].img})` }}
                              aria-hidden="true"
                            ></div>
                            <a
                              href={target.images[0] !== undefined && target.images[0].img}
                              rel="noreferrer"
                              target="_blank"
                            >
                              <ImagePlaceholder
                                src={target.images[0] !== undefined && target.images[0].img}
                                type={props.target}
                                className="firstCarouselButton d-block w-100"
                                alt=""
                              />
                            </a>
                          </div>
                          <p>{target.images[0].author}</p>
                        </div>
                      ) : null}

                      {target.images !== undefined && target.images[1] !== undefined && target.images[1].img ? (
                        <div className="carousel-item" data-bs-interval="1000000">
                          <div className="d-block w-100 carousel-image-frame">
                            <div
                              className="carousel-image-backdrop"
                              style={{ backgroundImage: `url(${target.images[1].img})` }}
                              aria-hidden="true"
                            ></div>
                            <a href={target.images[1].img} rel="noreferrer" target="_blank">
                              <ImagePlaceholder
                                src={target.images[1].img}
                                type={props.target}
                                className="secondCarouselButton d-block w-100"
                                alt=""
                              />
                            </a>
                          </div>
                          <p>{target.images[1].author}</p>
                        </div>
                      ) : null}

                      {target.images !== undefined && target.images[2] !== undefined && target.images[2].img ? (
                        <div className="carousel-item" data-bs-interval="1000000">
                          <div className="d-block w-100 carousel-image-frame">
                            <div
                              className="carousel-image-backdrop"
                              style={{ backgroundImage: `url(${target.images[2].img})` }}
                              aria-hidden="true"
                            ></div>
                            <a
                              href={
                                target.images !== undefined && target.images[2] !== undefined && target.images[2].img
                              }
                              rel="noreferrer"
                              target="_blank"
                            >
                              <ImagePlaceholder
                                src={
                                  target.images !== undefined && target.images[2] !== undefined && target.images[2].img
                                }
                                type={props.target}
                                className="thirdCarouselButton d-block w-100"
                                alt=""
                              />
                            </a>
                          </div>
                          <p>{target.images[2].author}</p>
                        </div>
                      ) : null}
                    </div>
                    <button
                      className="carousel-control-prev"
                      type="button"
                      data-bs-target="#carouselExampleAutoplaying3"
                      data-bs-slide="prev"
                    >
                      <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                      <span className="visually-hidden">Previous</span>
                    </button>
                    <button
                      className="carousel-control-next"
                      type="button"
                      data-bs-target="#carouselExampleAutoplaying3"
                      data-bs-slide="next"
                    >
                      <span className="carousel-control-next-icon" aria-hidden="true"></span>
                      <span className="visually-hidden">Next</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <hr></hr>

            <div className="profile-section profile-description">
              <div className="container">
                <h4>Opis</h4>
                {target.description.length < descriptionLength ? (
                  <div>
                    <p>{target.description}</p>
                    <p className="profile-description-author">{target.descriptionAuthor}</p>
                  </div>
                ) : (
                  <div className="profile-description-collapse">
                    {target.description.substring(0, descriptionLength)}
                    <div
                      ref={descriptionMoreRef}
                      className={`profile-description-more${isDescriptionExpanded ? " is-expanded" : ""}`}
                    >
                      {target.description.substring(descriptionLength, target.description.length)}
                      <p className="profile-description-author">{target.descriptionAuthor}</p>
                    </div>

                    <button
                      type="button"
                      className="profile-description-toggle"
                      onClick={() => setIsDescriptionExpanded((expanded) => !expanded)}
                      aria-expanded={isDescriptionExpanded}
                      aria-label={isDescriptionExpanded ? "Zwiń opis" : "Rozwiń opis"}
                    >
                      {isDescriptionExpanded ? "zwiń" : "rozwiń"}
                      <svg
                        className={`profile-description-toggle-icon${isDescriptionExpanded ? " is-expanded" : ""}`}
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        aria-hidden="true"
                      >
                        <path
                          d="M1 3 L5 7 L9 3"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                )}
              </div>
            </div>

            {target.location !== undefined ? (
              <div>
                <hr></hr>

                <div className="profile-section profile-location">
                  <h4>Lokalizacja</h4>
                  {target.location !== undefined ? (
                    <gmp-map ref={mapRef} zoom={mapZoom} map-id={target.title}>
                      <gmp-advanced-marker ref={mapMarkerRef} title={target.title}></gmp-advanced-marker>
                    </gmp-map>
                  ) : (
                    <div>
                      <p>Lokalizacja nie udostępniona</p>
                    </div>
                  )}
                </div>
              </div>
            ) : null}

            <hr></hr>

            <div className="profile-section profile-reviews">
              <h4>Recenzje</h4>
              <div>
                {target.reviews === undefined || target.reviews.length <= 0 ? (
                  <div>
                    <p>Brak recenzji</p>
                  </div>
                ) : (
                  <div>
                    {target.reviews.map((item) => {
                      return <Review key={item._id} item={item} />;
                    })}
                  </div>
                )}
              </div>
            </div>

            <hr></hr>

            <div className="profile-section profile-comments">
              <h4>Oceny i komentarze</h4>
              <div>
                {target.commentsAndRatings !== undefined && target.commentsAndRatings.length > 0
                  ? target.commentsAndRatings
                      .filter((item) => item.comment !== "")
                      .map((item) => {
                        return <Comment key={item._id} item={item} />;
                      })
                  : null}
              </div>
              <div>
                {checkForCreateComment() && props.userLogged && showCreateComment && props.userData.active ? (
                  <div>
                    <p className="profile-comment-form-title">Dodaj komentarz</p>
                    <CreateComment onAddComment={onAddComment} userData={props.userData} />
                  </div>
                ) : (
                  <div>
                    {props.userLogged ? (
                      props.userData.active ? (
                        <div>
                          <p>Dodałeś/aś już ocenę/komentarz</p>
                        </div>
                      ) : (
                        <div>
                          <p>Nie można dodać komentarza, email nie jest zweryfikowany.</p>
                          <p>W celu weryfikacji sprawdź swoją skrzynkę pocztową i kliknij w link aktywacyjny.</p>
                        </div>
                      )
                    ) : (
                      <p>Aby dodać komentarz musisz się zalogować</p>
                    )}
                  </div>
                )}
              </div>
              <div>
                <p style={{ color: responseText.color }}>{responseText.content}</p>
              </div>
            </div>
          </div>

          <div className="profile-bottom-text">
            <Link to={"/kontakt"}>Problem z tym miejscem? Kliknij i zgłoś</Link>
          </div>
        </div>
      )}
    </div>
  );
}

export default Profile;
